<mat-card-subtitle class="my-4">Session Timeout</mat-card-subtitle>
<avs-slider
  class="block ml-[234px] mb-5"
  (valueChanged)="onUpdate($event)"
  [disabled]="disabled()"
  [value]="client().clientUserSettings?.userSessionTimeoutMinutes!"
/>
